import { render, staticRenderFns } from "./ScheduledCallsCharts.component.vue?vue&type=template&id=23f87acf&scoped=true&"
import script from "./ScheduledCallsCharts.component.vue?vue&type=script&lang=js&"
export * from "./ScheduledCallsCharts.component.vue?vue&type=script&lang=js&"
import style0 from "./ScheduledCallsCharts.component.vue?vue&type=style&index=0&id=23f87acf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f87acf",
  null
  
)

export default component.exports